/**
 * 核心http
 * @description  request工具类 axios实例
 * @module core/request
 * @author yujingxuan
 */
import axios from 'axios';
import {
  requestInterceptor,
  requestRejectInterceptor,
  responseErrorHandler,
  responseSuccessHandler,
  responseSuccessVipHandler
} from './interceptor';

const isDev = process.env.NODE_ENV === 'development';

const createAxios = (baseURL) => {
  return axios.create({
    baseURL,
    timeout: 50000, // `timeout` 指定请求超时的毫秒数
    withCredentials: true, // 允许携带cookie
    transformRequest(data) {
      // `transformRequest` 允许在向服务器发送前，修改请求数据
      return new URLSearchParams(data).toString(); //对 data 进行任意转换处理
    },
  });
};

// 接口域名： https://pro.huxiu.com
const URL_API = process.browser ? '' : process.env.NEXT_PUBLIC_API_PRO;

// 接口域名： https://pro-api-account.huxiu.com
const URL_API_ACCOUNT = isDev && typeof window !== 'undefined' ? '/api-account' : process.env.NEXT_PUBLIC_API_ACCOUNT;

// 接口域名： https://pro-api-ms-account.huxiu.com
const URL_API_MS_ACCOUNT = isDev && typeof window !== 'undefined' ? '/api-ms-account' : process.env.NEXT_PUBLIC_API_MS_ACCOUNT;

// 接口域名： https://api-ms-log.huxiu.com
const URL_API_MS_LOG = isDev && typeof window !== 'undefined' ? '/api-ms-log' : process.env.NEXT_PUBLIC_API_MS_LOG;

// 接口域名： https://t-pro-api-vip.huxiu.com
const URL_API_VIP = isDev && typeof window !== 'undefined' ? '/api-vip' : process.env.NEXT_PUBLIC_API_VIP;

// 接口域名： https://t-pro-api-order.huxiu.com
const URL_API_ORDER = isDev && typeof window !== 'undefined' ? '/api-order' : process.env.NEXT_PUBLIC_API_ORDER;

// 接口域名： https://t-pro-api-order.huxiu.com
const URL_API_LIVE = isDev && typeof window !== 'undefined' ? '/api-live' : process.env.NEXT_PUBLIC_API_LIVE;
// // 接口域名： https://t-pro-api-action.huxiu.com
// const URL_API_ACTION = isDev && typeof window !== 'undefined' ? '/api-action' : process.env.NEXT_PUBLIC_API_ACTION;

/**
 * 依然建议一个接口域名对应一个axios实例
 * 这样每个实例都是相对自由的，可以在自己内部做不同的操作，如：JWT，不同的响应拦截
 */
const request = createAxios(URL_API);
request.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
request.interceptors.response.use(responseSuccessHandler, responseErrorHandler);

const requestAccount = createAxios(URL_API_ACCOUNT);
requestAccount.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
requestAccount.interceptors.response.use(responseSuccessHandler, responseErrorHandler);

const requestMsAccount = createAxios(URL_API_MS_ACCOUNT);
requestMsAccount.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
requestMsAccount.interceptors.response.use(responseSuccessHandler, responseErrorHandler);

const requestMsLog = createAxios(URL_API_MS_LOG);
requestMsLog.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
requestMsLog.interceptors.response.use(responseSuccessHandler, responseErrorHandler);

const requestVip = createAxios(URL_API_VIP);
requestVip.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
requestVip.interceptors.response.use(responseSuccessVipHandler, responseErrorHandler);

const requestOrder = createAxios(URL_API_ORDER);
requestOrder.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
requestOrder.interceptors.response.use(responseSuccessVipHandler, responseErrorHandler);


const requestLive = createAxios(URL_API_LIVE);
requestLive.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
requestLive.interceptors.response.use(responseSuccessHandler, responseErrorHandler);
// const requestLogin = createAxios(URL_API_ACTION);
// requestLogin.interceptors.request.use(requestInterceptor, requestRejectInterceptor);
// requestLogin.interceptors.response.use(responseSuccessHandler, responseErrorHandler);

export { request, requestAccount, requestMsAccount, requestMsLog, requestVip, requestOrder, requestLive };
